import React from 'react';
import styled from 'styled-components';
import { useState } from 'react';


const TagBtnBlock = styled.div`
    float: ${props => props.float || 'left'};
    text-align: center;
    margin: ${props => props.margin || '0px 0px'} ;
    width: ${props => props.width};
`;

const TagBtnSpanBlock = styled.span`
    display: inline-block;
    position: relative;
    line-height: 24px;
    padding: 0 9px;
    color: ${props => props.color || '#333'};
    background-color: ${props => props.bgColor || 'transparent'};
    border-radius: 12px;
    font-size: 14px;
    cursor: ${props => props.cursor2};//pointer;
    margin: 5px auto 5px;

    &:hover {
        background-color: ${props => props.active ? '#ffe7ad' : '#e0e0e0'};
    }

    &:hover .TagBtnDeleteBlockClass {
        display: ${props => props.active ? 'block' : 'none'};
    }
`;

const TagBtnDeleteBlock = styled.button`
    display: none;
    position: absolute;
    top: ${props => props.pos};
    right: ${props => props.pos};
    width: ${props => props.size};
    height: ${props => props.size};
    background-image: url(${props => props.img || ''});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
`;

const TagBtn = ({ active, text, width, float, isSmall, onClick, onDelClick, value, noDelBtn, margin }) => {

    const handleTagClick = () => {
        if(onClick === null || onClick === undefined){
            return;
        }
        onClick(value);
    }

    const handleDelClick = () => {
        if(onDelClick === null || onDelClick === undefined){
            return;
        }
        onDelClick(value);
    }

    return (
        <TagBtnBlock width={width} float={float}
            onClick={handleTagClick} margin={margin}>
            <TagBtnSpanBlock
                active={active}
                bgColor={active ? '#ffe7ad' : 'transparent'}
                cursor2={noDelBtn === "true" ? "auto" : "pointer"}>
                {text}
                <TagBtnDeleteBlock img="/assets/images/icon/tag_delete-icon.png"
                    className={noDelBtn ? "" : "TagBtnDeleteBlockClass"}
                    pos={isSmall ? '-6px' : '-8px'}
                    size={isSmall ? '15px' : '20px'}
                    onClick={handleDelClick} />
            </TagBtnSpanBlock>
        </TagBtnBlock>
    );
};

export default TagBtn;